import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import useInputObject from "../../hooks/useInputObject";
import { updateBuyer } from "../../http/api/BuyerAPI";
import BuyerInfo from "./BuyerInfo";
import validateBuyer from "./validBuyer";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規買人更新ページ
const BuyerEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const buyerInfo = useInputObject();

  useEffect(() => {
    buyerInfo.setValue(location.state.buyerInfo);
  }, [location.state.buyerInfo]);

  const handleClickReturn = (event) => {
    navigate(-1);
  };
  // 更新ボタンをクリックするイベント
  async function handleClickUpdate() {
    try {
      let updateItem = buyerInfo.Value;
      updateItem.updatedId = 1; //TODO JWTを追加した後削除
      console.log("Update Buyer data : ", updateItem);
      if (!checkValidBuyer(updateItem)) return;
      let response = await updateBuyer(updateItem);
      alert("買人を編集しました。");
      navigate("/company/buyer");
    } catch {
      alert("買人を編集できませんでした。");
    }
  }

  function checkValidBuyer(buyerInfo) {
    const errs = validateBuyer(buyerInfo);
    if (errs.length > 0) {
      console.log(errs);
      alert(errs.join("\n"));
      return false;
    }
    return true;
  }

  return (
    <CompanyTitledPage title="買人編集">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              買人情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickUpdate}
              id="buyer-form-submit-button"
            >
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 買人情報 */}
      <BuyerInfo buyerInfo={buyerInfo} isUpdateMode={true} />
    </CompanyTitledPage>
  );
};
export default BuyerEditPage;
